import { Form, Table, Typography } from 'antd';
import { forwardRef, useImperativeHandle } from 'react';

import TableComponent from 'components/Table/TableComponent';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import Content from 'layouts/Content';
import { formatCurrency } from 'utils/constants/functions';
interface IProps {
  data: any;
  plan: any;
  loading?: boolean;
}

const months = [
  'janSaleamt',
  'febSaleamt',
  'marSaleamt',
  'aprSaleamt',
  'maySaleamt',
  'junSaleamt',
  'julSaleamt',
  'augSaleamt',
  'sepSaleamt',
  'octSaleamt',
  'novSaleamt',
  'decSaleamt',
];

const TableCNPLanDetail = forwardRef<any, IProps>(
  ({ plan, data, loading }, ref: any) => {
    const { Text } = Typography,
      [form] = Form.useForm();

    const total = (data: readonly any[] | any) => {
      const monthlyTotals: any = months.reduce(
        (acc, val) => ({ ...acc, [val]: 0 }),
        {},
      );

      Array.isArray(data)
        ? data.forEach((item) =>
            months.forEach(
              (month) => (monthlyTotals[month] += Number(item[month])),
            ),
          )
        : Object.keys(monthlyTotals).map(
            (key) => (monthlyTotals[key] += data[key]),
          );

      const total = Object.values(monthlyTotals).reduce(
        (totalVal: number, currencyVal) => totalVal + Number(currencyVal),
        0,
      );

      return {
        totalOfAll: total,
        monthlyTotals: monthlyTotals,
      };
    };

    // const unit = 1000000;
    const columns: ColumnsTypeCustom = [
      {
        fixed: 'left',
        title: 'Đội',
        dataIndex: 'tteamSale',
        width: 220,
      },
      {
        title: 'Tháng 1',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'janSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: 'Tháng 2',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'febSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: 'Tháng 3',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'marSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: 'Tháng 4',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'aprSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: ' Tháng 5',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'maySaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: 'Tháng 6',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'junSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: 'Tháng 7',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'julSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: 'Tháng 8',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'augSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: 'Tháng 9',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'sepSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: 'Tháng 10',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'octSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: 'Tháng 11',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'novSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: 'Tháng 12',
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'decSaleamt',
        width: 150,
        render: (value) =>
          formatCurrency({
            value,
            round: true,
          }),
      },
      {
        title: `${Number(plan.year)}`,
        align: 'right',
        type: 'number',
        currency: 'vi-VN',
        dataIndex: 'year',
        width: 150,
        render(_, record) {
          const { totalOfAll } = total(record);

          return formatCurrency({
            value: totalOfAll,
            round: true,
          });
        },
      },
    ];

    useImperativeHandle(ref, () => ({ getData }));

    const getData = () => {
      const summary = total(data);
      const updatedData = data.map((record: any) => ({
        ...record,
        currency: 'Triệu VND',
        year: total(record).totalOfAll,
      }));
      updatedData.push({
        tteamSale: 'Tổng',
        ...summary.monthlyTotals,
        year: summary.totalOfAll,
        currency: 'Triệu VND',
      });

      const exportColumns = [
        ...columns,
        {
          title: 'Tiền tệ',
          dataIndex: 'currency',
          width: 100,
        },
      ];

      return { headerRow: exportColumns, datas: updatedData };
    };

    return (
      <Content>
        {/* <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingBottom: 10,
          }}
        >
          <Text className="text-[18px] leading-[22.4px] font-bold">
            {Number(plan.year)}
          </Text>
          <Text>Đơn vị: {plan.unitMoney || 'triệu VND'}</Text>
        </div> */}
        <Form form={form}>
          <TableComponent
            rowKey={(record: any) => record.id}
            dataSource={data}
            columns={columns}
            loading={loading}
            pagination={false}
            summary={(pageData) => {
              const { monthlyTotals, totalOfAll } = total(pageData);

              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>Tổng</Table.Summary.Cell>
                  {Object.values(monthlyTotals).map((value, index) => (
                    <Table.Summary.Cell
                      key={index}
                      index={index + 1}
                      className="text-right"
                    >
                      {formatCurrency({
                        value: Number(value),
                        round: true,
                      })}
                    </Table.Summary.Cell>
                  ))}
                  <Table.Summary.Cell index={1} className="text-right">
                    {formatCurrency({
                      value: Number(totalOfAll),
                      round: true,
                    })}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
          />
        </Form>
      </Content>
    );
  },
);

export default TableCNPLanDetail;
